import { createAction } from '@reduxjs/toolkit';
import type { DashboardState } from '../reducers/dashboard';
import type { AppThunk } from '../store/configureStore';
import { throwOnError } from './utils';

export const SET_DASHBOARD_STATS = createAction<DashboardState>('SET_DASHBOARD_STATS');

export const getDashboardStats =
  (query = ''): AppThunk =>
  (dispatch) =>
    fetch(`/api/dashboard?${query}`, {
      method: 'GET',
      credentials: 'same-origin',
    })
      .then<DashboardState>(throwOnError)
      .then((json) => dispatch(SET_DASHBOARD_STATS(json)));
